@use '../../../app/styles/common/mixins';

// Veon creatives are a fixed 300x250 medium rectangle. Reserve the box so the
// late client-side injection does not shift the layout (CLS).
$banner-width: 300px;
$banner-height: 250px;

.root {
  position: relative;
  width: $banner-width;
  max-width: 100%;
  min-height: $banner-height;

  // Center the banner on mobile and tablet; align it to the left from laptop up.
  margin-inline: auto;

  @include mixins.laptop {
    margin-inline: 0;
  }
}

.slot {
  width: 100%;
  min-height: $banner-height;
}

// The badge owns its own visuals (no design-system component)
.badge {
  position: absolute;
  left: 3px;
  bottom: 3px;
  padding: var(--spasing04);
  pointer-events: none;

  // No caption mixin matches this 10px / line-height-1 micro-label, so the type
  // is set by hand intentionally.
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  text-transform: uppercase;

  // White-on-black overlay badge: no semantic token matches pure white/black
  // at this 0.5 opacity, so the colors are set by hand intentionally.
  // stylelint-disable color-no-hex, color-hex-length
  color: #ffffff;
  background-color: #000000;
  // stylelint-enable color-no-hex, color-hex-length
  opacity: 0.5;
}
